export const CREATE_ORDER = 0
export const WAV = 1
export const MSQ = 2
export const RESULT = 3

export const departmentAdyyOptions = [{
  label: '安定医院',
  value: 'adyy'
}, {
  label: '安定医院-儿科',
  value: 'adyy-ek'
}]

export const departmentBitOptions = [{
  label: '北京理工大学',
  value: 'bit'
}, {
  label: '北京理工大学-精工书院',
  value: 'bit-jinggong'
}, {
  label: '北京理工大学-睿信书院',
  value: 'bit-ruixin'
}, {
  label: '北京理工大学-求是书院',
  value: 'bit-qiushi'
}, {
  label: '北京理工大学-明德书院',
  value: 'bit-mingde'
}, {
  label: '北京理工大学-特立书院',
  value: 'bit-teli'
}, {
  label: '北京理工大学-北京书院',
  value: 'bit-beijing'
}, {
  label: '北京理工大学-令闻书院',
  value: 'bit-lingwen'
}]
